import Vue from 'vue';
import Vuex from 'vuex';
import { activity, activityTyping, keyboard, error, application, student, accessibility } from './helpers';
import createEasyAccess from 'vuex-easy-access';
const easyAccess = createEasyAccess();
Vue.use(Vuex);
export const storeSetup = {
    plugins: [easyAccess]
};
export const { VUE_APP_TESTER } = process.env;
const store = new Vuex.Store(storeSetup);
activity.register(store);
activityTyping.register(store);
keyboard.register(store);
error.register(store);
application.register(store);
student.register(store);
accessibility.register(store);
export default store;
